import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import type { Validator } from "redux-form";
import {
  type ITextInputProps,
  TextInput,
} from "src/shared/forms/inputs/TextInput";

export interface IMerchantCooldownIntervalInputProps
  extends Omit<ITextInputProps, "label"> {}

export const MerchantCooldownIntervalInput = ({
  ...props
}: IMerchantCooldownIntervalInputProps) => {
  const validator = useMemo<Validator>(
    () => (value) => {
      if (!value && value !== 0) {
        return undefined;
      }
      const parsed = parseInt(value);
      if (!Number.isSafeInteger(parsed)) {
        return "Not integer";
      }
      if (parsed < 0) {
        return "not positive";
      }
      return undefined;
    },
    [],
  );
  return (
    <TextInput
      {...props}
      validate={validator}
      label={<FormattedMessage id="merchants.cooldownInterval" />}
    />
  );
};
